export default "__VITE_PUBLIC_ASSET__ae991f44__"